<template>
	<div>
		<div class="border-bottom pb-3 mb-6">
            <div class="display-3 kp-title">{{item.name}}</div>
        </div>
        <div class="border-bottom pb-3 mb-7">
            <div class="d-flex align-items-center mb-5">
                <h3 class="card-title mb-0 text-muted">Bucket Information</h3>                            
            </div>
            <div>
                <div class="row mb-2">
                    <label class="col-sm-3">Name</label>
                    <div class="col-sm-6">
                        <span>{{item.name}}</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-sm-3">Description</label>
                    <div class="col-sm-6">
                        <span>{{item.description}}</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-sm-3">Created</label>
                    <div class="col-sm-6">
                        <span>{{item.createdAt | df}}</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-sm-3">Track</label>
                    <div class="col-sm-6">
                        <router-link :to="{name: 'track-details', params: {id: item.track.id}}">
                        	{{item.track.name}}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="border-bottom pb-3 mb-7">
		    <div class="d-flex align-items-center mb-5">
		        <h3 class="card-title mb-0 text-muted">
		            Objects
		        </h3>
		    </div>
		    <div>
		        <table class="table table-vcenter table-edge">
		            <thead>
		                <tr>
		                    <th class="w-25">
		                        ID
		                    </th>
		                    <th>
		                        Object ID
		                    </th>
		                    <th>
		                    	Ext. ID
		                    </th>
		                    <th>
		                        Observer
		                    </th>
		                    <th>
		                        Added
		                    </th>
		                </tr>
		            </thead>
		            <tbody>
		                <tr v-for="item in items">
		                    <td>
		                        <router-link :to="{name: 'object-details', params: {id: item.id}}">{{item.id}}</router-link>
		                    </td>
		                    <td>{{item.object_id}}</td>
		                    <td>{{item.o_identifier}}</td>
		                    <td>
		                    	<router-link :to="{name: 'observer-details', params: {id: item.track_observer_id}}">
		                    		{{item.track_observer_id}}
		                    	</router-link>
		                    </td>
		                    <td>{{item.createdAt | df}}</td>              
		                </tr>		                                
		            </tbody>
		        </table>
		    </div>
		</div>		
	</div>
</template>

<script type="text/javascript">
	import {HTTP} from '@/components/HTTP.js'
	import DateFormat from '@/components/DateFilter.js'

	export default {
		created: function(){
			this.id = this.$route.params.id;
			this.fetch();
			this.details();
		},
		filters: {
			df: DateFormat
		},
		data: function(){
			return {
				id: "",
				items: [],
				item: {
					track: {}
				}		
			}
		},
		methods: {
			fetch: function(){
				HTTP.get('/e/rail/list/bucket/' + this.id)
	  			.then((res) => {
	  				if (res.data.status) {
	  					this.items = res.data.data.list;
	  				}	  				
	  			})
	  			.catch((e) => {
	  				console.log("Error response", e);
	  			})
			},
			details: function(){
				HTTP.get('/e/bucket/' + this.id)
	  			.then((res) => {
	  				if (res.data.status) {
	  					this.item = res.data.data.bucket;
	  				}	  				
	  			})
	  			.catch((e) => {
	  				console.log("Error response", e);
	  			})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/buckets/BucketDetails.vue